const orders = () => import('@/views/main/order/orders/orders.vue')
export default {
  path: '/main/order/orders',
  name: 'orders',
  component: orders,
  children: []
}
